export const personCareerSelector = state => state.personCareer;
